import { render, staticRenderFns } from "./3m.vue?vue&type=template&id=789f3ed9&"
import script from "./3m.vue?vue&type=script&lang=js&"
export * from "./3m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports